import { wgs84togcj02 } from '@/utils/postion'

export const createMarker = (lng, lat, params) => {
  // [AMap removed] Original implementation used AMap.Marker
  // [AMap removed] return new AMap.Marker({ position: wgs84togcj02(lng, lat), anchor: 'bottom-center', ...params })
  return null
}
